import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Menu, X } from 'lucide-react';
import InterlacedLogoV2 from '@/components/ui/InterlacedLogoV2';
const Navbar = () => {
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Hero tem min-h-screen, então usamos 85% da altura da viewport
      // Isso faz o background ficar preto antes do final do Hero
      setIsScrolled(window.scrollY > window.innerHeight * 0.85);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setMobileMenuOpen(false);
    }
  };
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-white/10 pt-[env(safe-area-inset-top)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 bg-black">
        <div className="flex justify-between items-center min-h-[64px]">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <InterlacedLogoV2 variant="horizontal" size="md" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <button onClick={() => scrollToSection('sobre')} className="text-white/80 hover:text-white transition-colors">
              Sobre
            </button>
            <button onClick={() => scrollToSection('como-funciona')} className="text-white/80 hover:text-white transition-colors">
              Como Funciona
            </button>
            <button onClick={() => scrollToSection('faq')} className="text-white/80 hover:text-white transition-colors">
              Perguntas Frequentes
            </button>
          </div>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center space-x-4">
            <Button variant="ghost" onClick={() => navigate('/auth')} className="text-white hover:bg-white/10">
              Entrar
            </Button>
            <Button onClick={() => navigate('/auth')} className="bg-gradient-to-b from-[#C4406B] to-[#9F3764] hover:from-[#9F3764] hover:to-[#8B1538] shadow-lg shadow-luxury-pink/20">
              Cadastrar
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden text-white" aria-label="Toggle menu">
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && <div className="lg:hidden py-4 space-y-4 border-t border-white/10">
            <button onClick={() => scrollToSection('sobre')} className="block w-full text-left text-white/80 hover:text-white transition-colors py-2">
              Sobre
            </button>
            <button onClick={() => scrollToSection('como-funciona')} className="block w-full text-left text-white/80 hover:text-white transition-colors py-2">
              Como Funciona
            </button>
            <button onClick={() => scrollToSection('faq')} className="block w-full text-left text-white/80 hover:text-white transition-colors py-2">
              Perguntas Frequentes
            </button>
            <div className="space-y-2 pt-4">
              <Button variant="outline" onClick={() => navigate('/auth')} className="w-full border-white/30 text-foreground bg-background">
                Entrar
              </Button>
              <Button onClick={() => navigate('/auth')} className="w-full bg-gradient-to-b from-[#C4406B] to-[#9F3764] hover:from-[#9F3764] hover:to-[#8B1538]">
                Cadastrar
              </Button>
            </div>
          </div>}
      </div>
    </nav>;
};
export default Navbar;